import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Select2Data } from 'ng-select2-component';
import { LogType, Status } from 'src/app/helpers/enum';
import { LocalCampaignOrderDataStatisticsModel, LocalCampaignOrderDataStatisticsTimechartModel } from 'src/app/models/renault-local-campaign-order-dto';
import { LocalCampaignOrderService } from 'src/app/services/local-campaign-order.service';
import Swal from 'sweetalert2';
import * as Highcharts from 'highcharts';


@Component({
  selector: 'local-campaign-statistics-sms',
  templateUrl: './local-campaign-statistics-sms.component.html',
  styleUrls: ['./local-campaign-statistics-sms.component.scss']
})
export class LocalCampaignStatisticsSmsComponent implements OnInit {

  @Input() idOrders: number[];
  modelStatistics: LocalCampaignOrderDataStatisticsModel;
  enviados = 0;
    enviadosPorc = 0;
    visitaTallerPorc = 0;
    facturacionMedia = 0;
  chartConversion: Highcharts.Chart;

  public optionCampaignConversionChart: any = {
    chart: {
      type: 'funnel',
      backgroundColor: 'transparent'
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      series: {
        borderColor: '#F1F1F2',
        borderWidth: 8,
        dataLabels: {
          format: '{point.name} {point.y:,.0f}'
        },
        center: ['50%', '50%'],
        width: '60%'
      }
    },
    legend: {
      enabled: false
    },
    series: [{
      name: 'Interacciones',
      data: []
    }]
  };

  constructor(private service: LocalCampaignOrderService) { }

  ngOnInit(): void {

    this.getStatistics();
    //this.getStatisticsConversionchart();

  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes["idOrders"] && changes["idOrders"].previousValue != undefined) {
      this.idOrders = changes["idOrders"].currentValue;
      this.getStatistics();

    }
    //this.getStatisticsConversionchart();

  }

  getStatisticsConversionchart() {
    this.service.getLocalCampaignOrderStatistics(this.idOrders).subscribe(resp => {
      Highcharts.setOptions({
        colors: ['#000000', '#5CBA63', '#FFBD69', '#4B9BF5', '#d8c4a0', '#CB4B32', '#60504a', '#66d8d0', '#244f35']
      });
      this.modelStatistics = resp;
      this.enviados = this.modelStatistics.Status.find(x => x.IdStatus == Status.Enviado)?.Contador ?? 0;
      this.enviadosPorc = this.enviados * 100 / this.modelStatistics.TotalBbdd;
      if(this.modelStatistics.TotalBbdd>=0) {
        this.optionCampaignConversionChart.series[0].data = [{
          y: this.modelStatistics.TotalBbdd,
          name: 'Contactos'
        }, {
          y: this.enviados,
          name: 'Éxito',
          percent: '(' + Math.round(this.enviadosPorc) + '%)'
        }, {
          y: this.enviados,
          name: 'Ventas'
        }];
        this.optionCampaignConversionChart.series[0].dataLabels = {
          format: '{point.name} {y} {point.percent}'
        };
      } else {
        this.optionCampaignConversionChart.series[0].remove();
      }
      this.chartConversion = Highcharts.chart('chartCampaignConversion', this.optionCampaignConversionChart);
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
    });
  }

  getStatistics() {
    this.service.getLocalCampaignOrderStatistics(this.idOrders).subscribe(resp => {
      this.modelStatistics = resp;
      this.enviados = this.modelStatistics.Status.find(x => x.IdStatus == Status.Enviado)?.Contador ?? 0;

      if (this.modelStatistics.TotalBbdd > 0)
        this.enviadosPorc = this.enviados * 100 / this.modelStatistics.TotalBbdd;

      if (this.enviados > 0)
        this.visitaTallerPorc = this.modelStatistics.VisitaTaller * 100 / this.enviados;

      if (this.modelStatistics.VisitaTaller > 0)
        this.facturacionMedia = this.modelStatistics.Facturacion / this.modelStatistics.VisitaTaller;

    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
    });
  }



}
